import React from 'react';
import { Breadcrumbs, Link, Typography, Chip } from '@mui/material';
import { Home, ChevronRight } from 'lucide-react';
import { useHftStore } from '../store';

const SEGMENT_LABELS: Record<string, string> = {
  nse_eq: 'NSE Equity',
  nse_fut: 'NSE Futures',
  nse_idx: 'NSE Indices',
  nse_opt: 'NSE Options',
};

export default function BreadcrumbNav() {
  const { stack, popTo, reset } = useHftStore();

  return (
    <Breadcrumbs
      separator={<ChevronRight size={14} />}
      sx={{ mb: 2, '& .MuiBreadcrumbs-li': { display: 'flex', alignItems: 'center' } }}
    >
      <Link
        component="button"
        underline="hover"
        onClick={reset}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}
      >
        <Home size={16} />
        Calendar
      </Link>

      {stack.slice(1).map((frame, i) => {
        const isLast = i === stack.length - 2;
        let label = '';

        switch (frame.view) {
          case 'day':
            label = frame.nav.date || '';
            break;
          case 'segment':
            label = SEGMENT_LABELS[frame.nav.segment || ''] || frame.nav.segment || '';
            break;
          case 'chain':
            label = `${frame.nav.underlying || ''} Chain`;
            break;
          default:
            label = frame.view;
        }

        if (frame.nav.symbol && frame.view === 'segment') {
          label += ` / ${frame.nav.symbol}`;
        }

        return isLast ? (
          <Chip key={i} label={label} size="small" color="primary" variant="outlined" />
        ) : (
          <Link
            key={i}
            component="button"
            underline="hover"
            onClick={() => popTo(i + 1)}
            sx={{ cursor: 'pointer' }}
          >
            {label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
